module.exports = __webpack_public_path__ + "media/images/shieldgps-logo1-gray-7fb44da8938e325d5b54e64c1689a814.svg";